import { render, staticRenderFns } from "./serveProject.vue?vue&type=template&id=9c9f8476&scoped=true&"
import script from "./serveProject.vue?vue&type=script&lang=js&"
export * from "./serveProject.vue?vue&type=script&lang=js&"
import style0 from "./serveProject.vue?vue&type=style&index=0&id=9c9f8476&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9f8476",
  null
  
)

export default component.exports